export const account = {
  'account.logged-out.title': 'Welcome to the sweet life',
  'account.logged-out.sign-in': 'Sign in',
  'account.logged-out.not-member': "Don't have an account?",
  'account.logged-out.join-now': 'Join now',
  'account.sidebar.sweetpass-membership': 'Sweetpass membership',
  'account.sidebar.sweetpass-join': 'Unlock benefits',
  'account.sidebar.sweetpass-join.tag': 'Explore',
  'account.sidebar.profile': 'Profile',
  'account.sidebar.payment-credit': 'Payment & Credit',
  'account.sidebar.addresses': 'Addresses',
  'account.sidebar.orders': 'Orders',
  'account.sidebar.favorites': 'Favorites',
  'account.sidebar.refer-friend': 'Refer a friend',
  'account.sidebar.dietary-restrictions': 'Dietary restrictions',
  'account.sidebar.contact-us': 'Contact us',
  'account.sidebar.terms': 'Terms',
  'account.sidebar.privacy-policy': 'Privacy policy',
  'account.sidebar.do-not-sell': 'Do not sell my personal information',
  'account.sidebar.instagram': 'Instagram',
  'account.sidebar.twitter': 'Twitter',
  'account.sidebar.tiktok': 'TikTok',
  'account.sidebar.spotify': 'Spotify',
  'account.sidebar.facebook': 'Facebook',
  'account.sidebar.sign-out': 'Sign out',
  'account.addresses.select-location.label': 'Select {text}',
  'account.addresses.select-location.hint': 'Selects location',
  'account.addresses.custom-name': 'Custom Name',
  'account.addresses.headline.edit': 'Edit Address',
  'account.addresses.headline.add': 'Add Address',
  'account.addresses.add-new': 'Add new address',
  'account.addresses.placeholder.delivery-note-a11y-label': 'Delivery Notes',
  'account.addresses.placeholder.delivery-note':
    'Courier notes, e.g. security code, building details...',
  'account.addresses.address-type.home': 'Home',
  'account.addresses.address-type.work': 'Work',
  'account.addresses.address-type.custom': 'Custom',
  'account.addresses.delivery-preference.leave-at-door': 'Leave at door',
  'account.addresses.delivery-preference.meet-at-door': 'Meet at door',
  'account.addresses.delivery-preference.meet-outside': 'Meet outside',
  'account.addresses.secondary-street': 'Apt number, suite, company',
  'account.addresses.drop-off': 'Drop-Off',
  'account.addresses.required': 'Required',
  'account.addresses.save': 'Save',
  'account.addresses.save.a11y': 'Submit address form',
  'account.addresses.remove-address.label': 'Remove',
  'account.addresses.remove-address.hint': 'Remove address',
  'account.addresses.address-label': 'Select {address} address',
  'account.addresses.address-hint': 'Selects address',
  'account.address.name-duplicate':
    'You already have an address with this name',
  'account.address.street-duplicate': 'You already have this address on file',
  'account.address.failure.generic':
    "Oops, we couldn't save your address, please try again.",
  'account.address.delete-failure.generic':
    "Oops, we couldn't remove your address, please try again.",
  'account.address.failure.street-number':
    'This address is not valid, please provide a street number.',
  'account.address.failure.zip-code':
    'This address is not valid, please provide a zip code.',
  'account.addresses.active-bag-warning.title':
    'You have an active bag with this address.',
  'account.addresses.active-bag-warning.subtitle':
    'If you proceed to edit or remove this address your bag will be cleared.',
  'account.addresses.active-bag-warning.cta': 'Edit address',
  'account.go-back': 'Back to account options',
  'account.profile.title': 'Profile',
  'account.profile.save': 'Save',
  'account.profile.cancel': 'Cancel',
  'account.profile.error':
    'Oops! We were unable to save your changes. Try again in a bit.',
  'account.sweetpass-membership.title': 'sweetpass membership',
  'account.sweetpass-membership.membership.title': 'Your membership level',
  'account.sweetpass-membership.membership.description': 'sweetpass member',
  'account.sweetpass-membership.membership.since': 'Member since {date}',
  'account.sweetpass-membership.membership.cta': 'Unlock more with sweetpass+',
  'account.payment-credit.title': 'Payment & Credit',
  'account.payment.title': 'Payment method',
  'account.payment.default': 'Default',
  'account.payment.expired': 'Card expired',
  'account.payment.expiring': 'Card will expire soon',
  'account.payment.new': 'Add credit or debit card',
  'account.credit.title': 'Credit',
  'account.credit.label': 'Total credit',
  'account.credit.mobile-label': 'Available credit',
  'account.credit.view-details': 'View details',
  'account.credit.close-details': 'Close details',
  'account.credit.expires': 'Expires {date}',
  'account.credit.field-placeholder': 'Add promo or gift code',
  'account.credit.a11y-label': 'Promo or gift code',
  'account.credit.helper-text':
    'If entering giftcard code, your giftcard amount will be transferred to your online credit card and you will no longer be able to use your physical gift card.',
  'account.credit.apply': 'Apply',
  'account.addresses.title': 'Addresses',
  'account.orders.title': 'Orders',
  'account.orders.load-more': 'See more orders',
  'account.orders.empty':
    'Once you place an order your history will appear here',
  'account.favorites.title': 'Favorites',
  'account.favorites.empty':
    'Once you favorite a product your favorites will appear here',
  'account.favorites.load-more': 'See more favorites',
  'account.favorites.quantity': 'Quantity: {quantity}',
  'account.favorites.add-to-bag': 'Add to bag',
  'account.refer-friend.title': 'Refer a friend',
  'account.refer-friend.subtitle': 'Give $7 + get $7',
  'account.refer-friend.description':
    "Invite your friends to download our app, and they'll each get $7 in credit to spend at sweetgreen. Once they spend their $7, you'll score $7 too!",
  'account.refer-friend.share.hint': 'Share via:',
  'account.refer-friend.share.title': "Here's $7 to spend @ sweetgreen",
  'account.refer-friend.share.body': `Hey! Download the sweetgreen app using my invite link and get $7 off your first order.%0D%0A{shareLink}`,
  'account.refer-friend.share.content':
    "Here's $7 to spend @ sweetgreen\n\nHey! Download the sweetgreen app using my invite link and get $7 off your first order.\n\n{shareLink}",
  'account.refer-friend.share.email': 'Email',
  'account.refer-friend.share.facebook': 'Facebook',
  'account.refer-friend.share.twitter': 'Twitter',
  'account.refer-friend.share.whatsapp': 'Whatsapp',
  'account.refer-friend.share.instagram': 'Instagram',
  'account.refer-friend.share.tiktok': 'Tiktok',
  'account.refer-friend.share.more': 'More',
  'account.refer-friend.copy.hint': 'Or copy the link:',
  'account.dietary-restrictions.title': 'Dietary restrictions',
  'account.credit-card-form.add': 'Add card',
  'account.credit-card-form.edit': 'Edit card',
  'account.credit-card-form.card-number': 'Card number',
  'account.credit-card-form.expiration-date': 'Exp. date',
  'account.credit-card-form.cvv': 'CVV',
  'account.credit-card-form.zip-code': 'Zip Code',
  'account.credit-card-form.nickname': 'Card nickname (optional)',
  'account.credit-card-form.default': 'Set as default payment method',
  'account.credit-card-form.close': 'Close credit card form',
  'account.credit-card-form.remove': 'Remove card',
  'account.credit-card-form.save': 'Save',
  'account.credit-card-form.number.error': 'Card Number is invalid',
  'account.credit-card-form.expiration.error': 'Invalid MM/YYYY',
  'account.credit-card-form.cvv.error': 'CVV Code is invalid',
  'account.credit-card-form.zipCode.error': 'Zip Code is invalid',
  'account.credit-card-form.invalid-submitted-billing-account':
    'We were unable to add your credit card. This generally means that your card has either expired, been canceled, or has insufficient funds. For questions, please email support@thelevelup.com.',
  'account.credit-card-form.invalid-postal-code':
    'Oops, that postal code is not valid.',
  'account.credit-card-form.too-many-requests':
    'Too many requests made. Please wait a bit and try again.',
  'account.credit-card-form.save-error-generic':
    "Oops, we couldn't save your card, please try again.",
  'account.credit-card-form.delete-error-generic':
    "Oops, we couldn't remove your card, please try again.",
  'account.credit-card-form.card-number.placeholder': '4111 1111 1111 1111',
  'account.credit-card-form.expiration-date.placeholder': 'MM / YYYY',
  'account.credit-card-form.cvv.placeholder': '123',
  'account.credit-card-form.zip-code.placeholder': '12345',
  'account.scan-to-pay.header.title': 'Scan to pay',
  'account.scan-to-pay.header.subtitle':
    'To pay in store, please scan this code at checkout',
  'account.scan-to-pay.payments': 'Payments',
  'account.scan-to-pay.promo-gift-code': 'Promo or gift code',
  'account.scan-to-pay.form-subtitle':
    'To use scan to pay please add a credit or debit card to your account.',
  'account.order-card.title': '{wantedTime, date, short} · {orderType}',
  'account.shared-by': 'By {name}',
  'account.notice.credit-applied': 'Credit added successfully',
  'account.notice.credit-invalid': 'This code or giftcard is not valid.',
  'account.scan-to-pay.scan-gift-code-message':
    'Align QR code in the box above & hold steady.',
  'account.scan-to-pay.scan-gift-code-camera-permission-message':
    'Refer to your device’s system settings to enable camera permissions.',
};
